import { gql } from '@apollo/client'
import { MUTATION_STATE, UPDATE_CREATION_PERCENTAGE_SHARE_FIELDS } from '../fragments'

const PAYLOAD = 'UpdateCreationPercentageSharePayload'

export const UPDATE_CREATION_PERCENTAGE_SHARE = gql`
    ${UPDATE_CREATION_PERCENTAGE_SHARE_FIELDS}
    ${MUTATION_STATE(PAYLOAD)}
    mutation updateCreationPercentageShare($creationId: ID!, $percentageShare: String) {
        updateCreationPercentageShare(input: { creationId: $creationId, percentageShare: $percentageShare }) {
            ...UpdateCreationPercentageShareFields
            ...MutationState${PAYLOAD}Fields
        }
    }
`
